import { useSyncExternalStore } from 'react'
import { useAuthStore } from '@/store/useAuthStore'

/** true une fois le persist Zustand (activeTeamId) rehydraté depuis localStorage. */
export function useAuthStorePersistHydrated(): boolean {
  return useSyncExternalStore(
    useAuthStore.persist.onFinishHydration,
    () => useAuthStore.persist.hasHydrated(),
    () => false
  )
}
